function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M203.2 137l-15.7-31.5v-.4c-.4-37.2-30.7-67.1-67.9-67.1-37.5 0-67.9 30.5-67.9 67.9 0 20.5 9 38.6 23.4 51.2v38.4c0 12.3 10.1 22.6 22.6 22.6h22.5c12.3 0 22.6-10.1 22.6-22.6h22.6c12.3 0 22.6-10.1 22.6-22.6v-22.6h7.3c6.6.3 11-7 7.9-13.3zm-47.4-31.6H127c-3.9 0-7.3 3.2-7.3 7.3v29.7c0 4.6-4.1 8.2-8.8 7.3-28-5.6-46.5-37.2-29.7-68.5 3.4-6 8.2-11 14.2-14.2 31.1-16.7 62.2 1.5 68.3 29 1.1 4.9-2.9 9.4-7.9 9.4z"
});

var SvgIconMentalHealth = function SvgIconMentalHealth(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256"
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgIconMentalHealth;